import { useState, useEffect } from "react";
import { callBackend } from "../components/callBackend";
import { Container } from "react-bootstrap";
import DataTable from "../components/DataTable";
import DownloadButton from "../components/DownloadButton";
import Loader from "../components/Loader";
import { NSSC_YEAR } from "../data/config";

export default function AllRegData() {
    const [count, setCount] = useState(0);
    const [partData, setPartData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    let pref = JSON.parse(localStorage.getItem("nssc-admin-pref"));
    const [tableControls, setTableControls] = useState(
        pref && pref.pageID === 1 && pref.v === 2
            ? pref
            : {
                  page: 1,
                  length: 100,
                  sortField: "_id",
                  sortDir: -1,
                  search: "",
              }
    );

    const columns = {
        _id: "Serial Number",
        pid: "PID",
        fName: "First Name",
        lName: "Last Name",
        college: "College/School",
        city: "City",
        state: "State/UT",
        paymentStatus: "Payment Status",
    };

    const downloadHeaders = [
        { label: "PID", key: "pid" },
        { label: "First Name", key: "fName" },
        { label: "Last Name", key: "lName" },
        { label: "Email Address", key: "email" },
        { label: "Phone Number", key: "phone" },
        { label: "Gender", key: "gender" },
        { label: "Date of Birth", key: "dob" },
        { label: "Level of Study", key: "level" },
        { label: "Name of Institution", key: "college" },
        { label: "City", key: "city" },
        { label: "State/UT", key: "state" },
        { label: "Payment Status", key: "paymentStatus" },
    ];

    const getPartData = async () => {
        if (!localStorage.getItem("nssc-admin-token")) {
            window.location.href = "/login";
            return;
        }

        setIsLoading(true);

        callBackend({
            method: "GET",
            endpoint: "/admin/reg/",
            data:
                `sortField=${tableControls.sortField}` +
                `&sortDir=${tableControls.sortDir}` +
                `&first=${0 + tableControls.length * (tableControls.page - 1)}` +
                `&limit=${tableControls.length}` +
                `&search=${encodeURIComponent(tableControls.search || "")}`,
            onSuccess: (res) => {
                setPartData(res.data);
                setCount(res.count);
                setIsLoading(false);
            },
            onError: (error) => {
                console.error("Failed to fetch data:", error);
                setIsLoading(false);
            },
        });
    };

    useEffect(() => {
        getPartData();
        localStorage.setItem(
            "nssc-admin-pref",
            JSON.stringify({ ...tableControls, pageID: 1, v: 2 })
        );
    }, [tableControls]);

    const styles = {
        container: {
            marginTop: "40px",
            marginBottom: "40px",
            padding: "30px",
            backgroundColor: "#ffffff",
            borderRadius: "12px",
            boxShadow: "0 4px 16px rgba(0,0,0,0.1)",
        },
        heading: {
            fontSize: "1.8rem",
            fontWeight: "600",
            color: "#0a192f",
            display: "inline-block",
            paddingBottom: "8px",
            marginBottom: "24px",
        },
    };

    return (
        <Container fluid style={styles.container}>
            <h1 style={styles.heading}>NSSC {NSSC_YEAR} Website Registrations</h1>

            {isLoading ? (
                <Loader />
            ) : (
                <DataTable
                    columns={columns}
                    data={partData}
                    count={count}
                    tableControls={tableControls}
                    setTableControls={setTableControls}
                    downloadButton={
                        <DownloadButton
                            endpoint={"/admin/download/reg/"}
                            downloadHeaders={downloadHeaders}
                        />
                    }
                />
            )}
        </Container>
    );
}
